'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _StringColumn2 = require('./StringColumn');

var _StringColumn3 = _interopRequireDefault(_StringColumn2);

var _localize = require('../../core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Resx = (0, _localize2.default)('Common');

var Select2BaseColumn = function (_StringColumn) {
	_inherits(Select2BaseColumn, _StringColumn);

	function Select2BaseColumn() {
		_classCallCheck(this, Select2BaseColumn);

		return _possibleConstructorReturn(this, (Select2BaseColumn.__proto__ || Object.getPrototypeOf(Select2BaseColumn)).apply(this, arguments));
	}

	_createClass(Select2BaseColumn, [{
		key: 'getFilterText',


		// -------------- FILTERS --------------------

		value: function getFilterText() {
			return this.getSelect2Filter().select2('data').filter(function (x) {
				return x.id;
			}).map(function (x) {
				return x.text;
			}).pop() || "";
		}
	}, {
		key: 'setFilterValue',
		value: function setFilterValue(value) {
			this.column.filter().find('select.table-filter').val(value || '').trigger('change');
		}
	}, {
		key: 'setFilterFocus',
		value: function setFilterFocus() {
			var _this2 = this;

			setTimeout(function () {
				_this2.getSelect2Filter().select2("open");
			}, 100);
		}
	}, {
		key: 'getSelect2Filter',
		value: function getSelect2Filter() {
			return this.column.filter().find('select.table-filter');
		}
	}, {
		key: 'getFilterAllText',
		value: function getFilterAllText() {
			return Resx.Common.All;
		}
	}, {
		key: 'showFilterButton',
		value: function showFilterButton() {
			return false;
		}
	}, {
		key: 'onFilterRendered',
		value: function onFilterRendered() {
			this.column.filter().find('.filter-box-wrap').css('width', '250px').addClass('filter-box-select');
		}

		// ------------- EDITOR -----------------

	}, {
		key: 'onEditorCreated',
		value: function onEditorCreated(cellElement) {
			var _this3 = this;

			cellElement.find('select').on('select2:close', function (e) {
				_this3.api.editor().submitChanges();
				(0, _jquery2.default)(e.target).data('isClosing', true);
			}).on('select2:opening', function (e) {
				if ((0, _jquery2.default)(e.target).data('isClosing')) {
					return false;
				}
			});
		}
	}]);

	return Select2BaseColumn;
}(_StringColumn3.default);

exports.default = Select2BaseColumn;


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/data-tables/renderers/Select2BaseColumn.js
// module id = 581
// module chunks = 1